// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ProNestedFormController from "./pro_nested_form_controller"
application.register("pro-nested-form", ProNestedFormController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import AdminEventsFilterController from "./admin_events_filter_controller"
application.register("admin-events-filter", AdminEventsFilterController)

import AdminEventFilterCheckboxController from "./admin_event_filter_checkbox_controller"
application.register("admin-event-filter-checkbox", AdminEventFilterCheckboxController)
